import OrganizationModel from "src/models/OrganizationModel";
import getUserAge from "src/utils/getUserAge";
import renderEmail from "src/utils/renderEmail";

interface MoveConfirmationEmailInput {
  organization: OrganizationModel;
  accountOwner: {
    firstName: string;
  };
  currentStudent: {
    birthDate: Date;
    firstName: string;
    lastName: string;
  };
  targetStudent: {
    birthDate: Date;
    firstName: string;
    lastName: string;
  };
}

const StudentMerge = (vars) => ({
  subject: `Participant Merge - ${vars.organizationName}`,
  html: `<p>Dear ${vars.firstName},</p>

<p>Participant details and enrollment history for Participant ${vars.currentStudentFullNameAndAge} has been merged with Participant ${vars.targetStudentFullNameAndAge}.</p>

<p>Billing history is not transferred between accounts. Active enrollments and recurring charges (if any) for ${vars.currentStudentFullNameAndAge} have been canceled.</p>

<p>If you have any questions, please let us know.</p>

<p>Sincerely,<br />
${vars.organizationName}</p>`,
});

export default ({
  organization,
  accountOwner,
  currentStudent,
  targetStudent,
}: MoveConfirmationEmailInput) => {
  const template = StudentMerge;

  const currentStudentAge = getUserAge(currentStudent.birthDate);
  const targetStudentAge = getUserAge(targetStudent.birthDate);

  const variables = {
    organizationName: organization.title,
    firstName: accountOwner.firstName,
    currentStudentFullNameAndAge: `${currentStudent.firstName} ${currentStudent.lastName} (${currentStudentAge.ageNumber} ${currentStudentAge.ageUnit})`,
    targetStudentFullNameAndAge: `${targetStudent.firstName} ${targetStudent.lastName} (${targetStudentAge.ageNumber} ${targetStudentAge.ageUnit})`,
    organizationUrl: `https://${organization.subdomain}.captyn.com`,
  };

  const email = renderEmail({
    template,
    variables,
  });

  return email;
};
